//noScroll
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    /* news　カテゴリー選択  */
    const newsCatSelect = () => {

    const newsCats = document.querySelectorAll(".js-cat");
    const newsArticle = document.querySelectorAll(".news-article")

      newsCats.forEach((cat, i) => {
        cat.addEventListener("click", () => {
          const isActiveCat = document.querySelector(".is-catActive")
          const isShowCat = document.querySelector(".is-catShow")
          
          isActiveCat.classList.remove("is-catActive")
          cat.classList.add("is-catActive")


          isShowCat.classList.remove("is-catShow")
          newsArticle[i].classList.add("is-catShow")
        })
      })
    }
    newsCatSelect();

    /* 施設写真スライダー  */
    const swiper = new Swiper(".top-swiper", {

      loop:true,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      spaceBetween: 10,
      slidesPerView: 1.2,


      breakpoints: {

        // 768px以上の場合
        960: {
          slidesPerView: 3.2,
          spaceBetween: 10,
        }
      },

    });
    
    /* 背景固定  */
    
    gsap.registerPlugin(ScrollTrigger);
    
    ScrollTrigger.create({
    trigger: ".guide-hotSpring",
    pin: true,
    start: "top center",
    end: 'bottom 0%',
    // endTrigger: ".p-top__news",
    toggleClass: {targets: ".guide-hotSpring", className: "is-active"}, //クラスをつけたり、外したりできる
    // markers: true,
    });
    
    
    /* MVアニメーション */
    const mvAnimation = () => {
    let tl = gsap.timeline({repeat: 0, repeatDelay: 1});
    
    tl.fromTo(".ttl-01", .7,
      {
        autoAlpha: 0,
        scale: 0.8,
    
      }, {
        autoAlpha: 1,
        scale: 1,
    
      }
    );
    tl.fromTo('.ttl-02', .7, {
      autoAlpha: 0,
      scale: 0.8,
    
    }, {
      autoAlpha: 1,
      scale: 1,
    
    })
    tl.fromTo('.ttl-03', .7, {
      autoAlpha: 0,
      scale: 0.8,
    
    }, {
      autoAlpha: 1,
      scale: 1,
    
    },
    )
    tl.fromTo('.mv-logo', .7, {
      autoAlpha: 0,
    
    
    }, {
      autoAlpha: 1,
    },
    )
    tl.fromTo('.mv-sideTtl', .7, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      onComplete: function() {
        $('html').addClass('is-nav-active');
      }
    },"<"
    )
    tl.fromTo('.l-header__inner', .7, {
      autoAlpha: 0,
      y: -50, // 垂直方向
    }, {
      autoAlpha: 1,
      y: 0, // 垂直方向
    },
    )
    tl.fromTo('.l-header-sns, .l-header__sns', .7, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      onComplete: function() {
        $(".l-header__inner, .l-header-sns, .l-header__sns").addClass('is-active');
      }
    },
    )
    tl.fromTo('.mv-scroll', .3, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
    
    },
    "<"
    )
    
    }

    $(window).scroll(function() {
      if($('html').hasClass('is-scroll') == false && $('html').hasClass('is-nav-active') == false) {
        let tl_s = gsap.timeline({repeat: 0, repeatDelay: 1});

        tl_s.fromTo('.l-header__inner', .01, {
          autoAlpha: 1,
        
        }, {
          autoAlpha: 1,
          onComplete: function() {
            $('html').addClass('is-nav-active');
          }
        },
        )
        tl_s.fromTo('.l-header__inner', .7, {
          autoAlpha: 0,
          y: -50, // 垂直方向
        
        }, {
          autoAlpha: 1,
          y: 0, // 垂直方向
        },
        )
        tl_s.fromTo('.l-header-sns, .l-header__sns', .7, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          onComplete: function() {
            $(".l-header__inner, .l-header-sns, .l-header__sns").addClass('is-active');
          }
        },
        )
        $('html').addClass('is-scroll');
      }
    })
    
    
    const firstViewFlag = () => {
    
    const keyName = 'firstView';
    
    /// そのcookie値を取得
    const value = document.cookie
      .split(/;\s*/)
      .find(row => {
        const [key, value] = row.split("=")
        return key === keyName
      }).split('=')[1];
    
    if(value === "true"){
      setTimeout(mvAnimation,2000)
    }else{
      setTimeout(mvAnimation,600)
    }
    
    }
    
    firstViewFlag();
  }
}


